import React from 'react'

export const TitulosDinamicos = ( {title = 'selecione video'} ) => {
    return (
        <>
            <p className="text-center fs-2 text-muted fw-bolder capitalize">{title}</p>
        </>
    )
}
